import type { ReactNode } from 'react';
import { Link } from '../router';
import { useSites } from '../state/sites';
import { Empty, ErrorNotice, Loading } from '../ui/kit';
import { ConfigDraftProvider, useDraft } from './draft';

function Gate({ children }: { children: ReactNode }) {
  const d = useDraft();
  if (d.loading) return <Loading label="Loading your widget settings" />;
  if (d.loadError) return <ErrorNotice error={d.loadError} title="Could not load the widget settings" />;
  return <>{children}</>;
}

/** Mounts the draft provider for the current site (live key, test twin mirrored). */
export function WithSiteDraft({ children }: { children: ReactNode }) {
  const { current, loading } = useSites();
  if (loading) return <Loading />;
  if (!current)
    return (
      <Empty title="No site yet">
        Create a site first: it gives you the key these settings belong to. <Link to="/sites">Create a site</Link>
      </Empty>
    );
  return (
    <ConfigDraftProvider key={current.live.site_key} siteKey={current.live.site_key} testSiteKey={current.test?.site_key ?? null}>
      <Gate>{children}</Gate>
    </ConfigDraftProvider>
  );
}
